export interface LeadColumn {
  key: string;
  label: string;
}

export const ALL_LEAD_COLUMNS: LeadColumn[] = [
  { key: 'sno',          label: 'S.No' },
  { key: 'leadNo',       label: 'Lead No' },
  { key: 'source',       label: 'Lead Source' },
  { key: 'contact',      label: 'Name' },
  { key: 'email',        label: 'Email' },
  { key: 'phone',        label: 'Phone' },
  { key: 'created',      label: 'Created' },
  { key: 'status',       label: 'Status' },
  { key: 'followup',     label: 'Follow-up' },
  { key: 'meeting',      label: 'Meeting' },
  { key: 'score',        label: 'Score' },
  { key: 'priority',     label: 'Priority' },
  { key: 'country',      label: 'Country' },
  { key: 'state',        label: 'State' },
  { key: 'city',         label: 'City' },
  { key: 'zipcode',      label: 'Zipcode' },
  { key: 'assignedTo',   label: 'Assigned To' },
  { key: 'campaign',     label: 'Campaign' },
  { key: 'leadCategory', label: 'Lead Category' },
  { key: 'leadColor',    label: 'Lead Color' },
  { key: 'hashtags',     label: 'Hashtags' },
  { key: 'description',  label: 'Description' },
];

export const FACTORY_DEFAULT_COLUMNS = [
  'sno', 'leadNo', 'source', 'contact', 'email', 'phone', 'created', 'status', 'followup', 'meeting', 'priority', 'country', 'state',
];

const userColsKey = (userId: string) => `lead_columns_${userId}`;
const vendorHashKey = (userId: string) => `lead_columns_vendor_hash_${userId}`;

export function loadUserColumns(userId: string): string[] | null {
  try {
    const v = localStorage.getItem(userColsKey(userId));
    if (v) return JSON.parse(v);
  } catch {}
  return null;
}

export function saveUserColumns(userId: string, cols: string[], vendorHash: string): void {
  localStorage.setItem(userColsKey(userId), JSON.stringify(cols));
  localStorage.setItem(vendorHashKey(userId), vendorHash);
}

export function loadStoredVendorHash(userId: string): string | null {
  return localStorage.getItem(vendorHashKey(userId));
}

export function vendorHash(cols: string[]): string {
  return JSON.stringify(cols);
}
